import {
  Container,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";

function AddBeautician() {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({}); // <== Save all form data here

  const steps = [
    "Personal Info",
    "Documents Upload",
    "Category",
    "Locations",
    "Time-Slots",
  ];

  const handleNext = (dataFromStep) => {
    // Merge new data from current step into existing formData
    setFormData((prev) => ({ ...prev, ...dataFromStep }));
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const getStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <Step1 onNext={handleNext} />;
      case 1:
        return (
          <Step2
            val={formData}
            onNext={() => setActiveStep((prev) => prev + 1)}
          />
        );
      case 2:
        return (
          <Step3
            val={formData}
            onNext={() => setActiveStep((prev) => prev + 1)}
          />
        );
      case 3:
        return (
          <Step4
            val={formData}
            onNext={() => setActiveStep((prev) => prev + 1)}
          />
        );
      case 4:
        return (
          <Step5
            val={formData}
            // onNext={() => setActiveStep((prev) => prev + 1)}
          />
        );

      default:
        return <div>Done</div>;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h4">{`Step ${activeStep + 1}: ${
          steps[activeStep]
        }`}</Typography>
        <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {getStepComponent()}
        </Paper>
      </Container>
    </DashboardLayout>
  );
}

export default AddBeautician;
